export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20background%20with%20warm%20red%20and%20gold%20gradient%20atmosphere%2C%20soft%20bokeh%20lights%20scattered%20like%20film%20grain%2C%20elegant%20theater%20curtain%20texture%20in%20deep%20crimson%20tones%2C%20subtle%20spotlight%20effect%20from%20upper%20left%2C%20no%20text%20or%20letters%2C%20sophisticated%20movie%20premiere%20vibe%2C%208K%20cinematic%20quality&width=1920&height=800&seq=hero-bg-luobo-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-0">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/15 border border-primary-500/25 mb-5">
              <i className="ri-fire-line text-primary-400 text-sm"></i>
              <span className="text-primary-300 text-xs font-medium whitespace-nowrap">
                每日更新 · 全集收录
              </span>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-5xl text-foreground-50 leading-tight mb-3">
              萝卜影视 — 电视剧全集与连续剧完整版在线观看
            </h1>

            <p className="text-foreground-300 text-base md:text-lg mb-2 font-heading">
              无需等待更新，一次追完整部剧
            </p>

            <div className="text-foreground-400 text-sm md:text-base leading-relaxed space-y-2 mb-8 max-w-[600px] mx-auto lg:mx-0">
              <p>
                萝卜影视专注收录海量电视剧全集、连续剧完整版与电视剧大结局，覆盖国产剧、韩剧、美剧、日剧等热门类型。
              </p>
              <p>
                所有剧集均支持高清播放、流畅不缓冲，无需注册即可免费在线观看。无论你是追新剧还是补经典，萝卜影视都能让你一次看个够。
              </p>
              <p>
                本站每日同步最新剧集资源，确保大结局第一时间上线，让追剧不再被"更新中"打断节奏。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="flex flex-col items-center">
                <span className="font-heading text-2xl md:text-3xl text-accent-400">2000+</span>
                <span className="text-foreground-400 text-xs mt-1">部电视剧全集</span>
              </div>
              <div className="w-px h-10 bg-foreground-700/30 hidden sm:block"></div>
              <div className="flex flex-col items-center">
                <span className="font-heading text-2xl md:text-3xl text-accent-400">每日更新</span>
                <span className="text-foreground-400 text-xs mt-1">同步最新剧集</span>
              </div>
              <div className="w-px h-10 bg-foreground-700/30 hidden sm:block"></div>
              <div className="flex flex-col items-center">
                <span className="font-heading text-2xl md:text-3xl text-accent-400">高清流畅</span>
                <span className="text-foreground-400 text-xs mt-1">播放不缓冲</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-primary-500 hover:bg-primary-600 text-foreground-50 font-medium text-sm whitespace-nowrap cursor-pointer transition-colors duration-200 flex items-center justify-center gap-2"
              >
                <i className="ri-play-circle-line text-base"></i>
                开始追剧
              </a>
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3.5 rounded-lg border border-foreground-300/30 hover:border-foreground-300/60 text-foreground-200 hover:text-foreground-50 font-medium text-sm whitespace-nowrap cursor-pointer transition-colors duration-200 flex items-center justify-center gap-2"
              >
                <i className="ri-trophy-line text-base"></i>
                查看追剧榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 rounded-2xl bg-primary-500/10 blur-3xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20film%20reel%20and%20warm%20theater%20spotlight%20composition%2C%20elegant%20dark%20red%20velvet%20curtain%20draped%20on%20sides%2C%20floating%20film%20strips%20with%20subtle%20glow%2C%20golden%20particles%20floating%20in%20air%2C%20sophisticated%20movie%20award%20ceremony%20aesthetic%2C%20no%20text%2C%20warm%20dramatic%20lighting&width=600&height=750&seq=hero-visual-luobo-01&orientation=portrait"
                alt="萝卜影视 - 电视剧全集在线观看"
                className="relative w-full h-auto rounded-xl object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}